export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_RELOAD = 'SET_RELOAD';
